/**
 * Angular JS Stockists Controller
 *
 * @category Controllers
 * @package Common
 * @author Chris <chriswelland@yellostudio.co.uk>
 * @copyright (c) 2016, Yello Studio
 * @version 0.1
 */

(function(){

    'use strict';

    var CountryFilter = function(){
      return function(retailers, country){
        return retailers.filter(function(retailer){
          return retailer.country == country;
        });
      };
    };


    var StockistController = function($scope, $http, $filter, $timeout){

        var _this   = this;


        this.lat     =  parseFloat(document.getElementById('googleMap').getAttribute('data-lat'));
        this.lng     =  parseFloat(document.getElementById('googleMap').getAttribute('data-lng'));
        this.country = document.getElementById('googleMap').getAttribute('data-country');

        $scope.show_address = false;
        $scope.open         = false;
        $scope.bounds       = new google.maps.LatLngBounds();

        $scope.markers = [];
        $scope.results = [];

        $scope.selectedRetailer = {};

        // Construct the StockistController
        this.construct = function(){
          $scope.map = new google.maps.Map(document.getElementById('googleMap'), {
            center: {lat: _this.lat, lng: _this.lng},
            scrollwheel: false,
            zoom: 8,
            mapTypeId:"roadmap"
          });

          _this.getRetailers();
        };

        // Get retailers
        this.getRetailers = function(){
          $http({ url:'/api/retailers', type:'GET' })
              .then(function(response){
                  if(response.error){
                      console.log("ERROR: Unable to retrieve retailers");
                  } else {
                    $scope.countries = response.data.countries;
                    $scope.retailers = response.data.retailers;
                    if(_this.country){
                        _this.country = _this.country.replace('United Kingdom', 'UK');
                        $scope.stockistCountry = _this.country.toLowerCase();
                        $scope.selectCountry()
                    }
                  }
              }, function(response){
                  console.log("ERROR: Endpoint not functioning");
              });
        };

        $scope.showAllRetailers = function(){
          _this.clearMarkers();
          _this.populateRetailers($scope.retailers);
          $scope.map.fitBounds($scope.bounds);
          $scope.stockistCountry = '';

        };

        $scope.scrollToResult = function(id){

          var element = $('search-results li[data-id="'+id+'"]');
          var top = element.offset().top - 150;

          $('html, body').animate({ scrollTop: top}, 500, function(){
            element.addClass('highlight');
            setTimeout(function(){ element.removeClass('highlight'); }, 1000);
          });
        };

        $scope.selectRetailer = function(id){

          var index = $scope.results.findIndex(function(retailer){
            return retailer.id == id;
          });

          var temp = $scope.results[index];

          $timeout(function(){
            $scope.results.splice(index, 1);
            $scope.results.unshift(temp);
            $scope.results[0].selected = true;
            $timeout(function(){ $scope.results[0].selected = false; }, 1000);
          });

        };

        this.clearMarkers = function(){
          angular.forEach($scope.markers, function(marker){
              marker.setMap(null);
          });
          $scope.bounds = new google.maps.LatLngBounds();
          $scope.markers = [];
          $scope.results = [];
        };


        $scope.selectCountry = function(){

          _this.clearMarkers();

          var filteredRetailers = $filter('CountryFilter')($scope.retailers, $scope.stockistCountry);

          _this.populateRetailers(filteredRetailers);

          var zoomChangeBoundsListener;
          google.maps.event.addListener($scope.map, 'zoom_changed', function() {
              zoomChangeBoundsListener =
                  google.maps.event.addListener($scope.map, 'bounds_changed', function(event) {
                      if (this.getZoom() > 13 && this.initialZoom === true) {
                          // Change max/min zoom here
                          this.setZoom(13);
                          this.initialZoom = false;
                      }
                  google.maps.event.removeListener(zoomChangeBoundsListener);
              });
          });

          $scope.open = true;
          google.maps.event.trigger($scope.map, "resize");

          if($scope.markers.length < 2){
            $scope.map.setZoom(14);
          }

          $timeout(function(){
            $scope.map.initialZoom = true;
            $scope.map.fitBounds($scope.bounds);
            $('search-results').show();
          }, 200);

        };


        this.populateRetailers = function(filteredRetailers){
          angular.forEach(filteredRetailers, function(retailer){

            var position = new google.maps.LatLng(retailer.latlng[0], retailer.latlng[1]);
            $scope.bounds.extend(position);
            var marker = new google.maps.Marker({
                position: position,
                map: $scope.map,
                //visible: !retailer.onlineOnly,
                title:retailer.title,
                id: retailer.id
            });

            marker.addListener('click', function() {
               $scope.map.setZoom(14);
               $scope.map.setCenter(marker.getPosition());
               //$scope.scrollToResult(marker.id);
               $scope.selectRetailer(marker.id);
            });

            $scope.markers.push(marker);
            $scope.results.push(retailer);

          });

        };

        this.construct.apply(this, arguments);

    };

    angular.module('App')
      .filter('CountryFilter', CountryFilter)
      .controller('StockistController', StockistController);

})();
